import { FC, useRef, MouseEvent } from "react";
import styles from "./product-card-3.module.css";
import { CallerEnum, CardSliderDirection, CardType } from "../../product-card.types";
import HighlightStarBox from "../../components/highlight-star-box";
import WholesaleBox from "../../components/wholesale-box";
import ProductCardSelector from "../../../product-card-selector/product-card-selector";
import { AppLink, useProductCardLogic } from "@commons-monorepo/index";
import { ProductCardProps } from "../../product-card.types";
import KitTag from "../../components/kit-tag";

interface Props extends ProductCardProps {
  type?: CardType;
}
const ProductCard3: FC<Props> = ({
  product,
  type = CardType.Type3,
  withTags,
  cartProducts,
  theme,
  addProduct,
  removeProduct,
  manuallyChangeProduct,
  locale,
  currency,
  storeMetadata,
  caller = CallerEnum.ProductGrid,
  ComponentLinks
}) => {
  const {
    hasDiscount,
    images,
    percentageDiscount,
    isWholesale,
    isHighlight,
    isKit,
    finalPrice,
    formattedFinalPrice,
    formattedWithoutDiscountPrice,
    urlProductDetail
  } = useProductCardLogic({ product, locale, currency, storeMetadata });
  const sliderRef = useRef<HTMLDivElement>(null);

  const handleMoveSlider = (direction: CardSliderDirection, e?: MouseEvent<HTMLButtonElement>): void => {
    const CALCULATION_ERROR = 20;
    if (!!sliderRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;
      if (direction === CardSliderDirection.Left) {
        sliderRef.current.scrollLeft = scrollLeft < clientWidth ? scrollWidth : scrollLeft - clientWidth;
      } else {
        sliderRef.current.scrollLeft =
        scrollLeft + clientWidth + CALCULATION_ERROR >= scrollWidth ? 0 : scrollLeft + clientWidth;
      }
    }
    e && e.stopPropagation();
  };

  return (
    <div className={`${styles.productCard3Wrapper} ${styles[type]}`}>
      <figure className={styles.img}>
        <AppLink
          to={urlProductDetail()}
          Component={ComponentLinks}>

          <div ref={sliderRef} className={styles.slider}>
            {[CardType.Type5].includes(type) ?
            <>
                <img
                loading='lazy'
                alt={product?.name}
                src={images[0]?.url}
                className={`${styles.productImage} ${styles.one} ${images.length > 1 && styles.animate}`} />

                {images.length > 1 &&
              <img
                loading='lazy'
                alt={product?.name}
                src={images[1].url}
                className={`${styles.productImage} ${styles.two} ${images.length > 1 && styles.animate}`} />}


              </> :
            [CardType.Type3, CardType.Type4, CardType.Type6].includes(type) ?
            images.map((i, index) =>
            <img
              loading='lazy'
              key={`product-card-3-image-${index}`}
              alt={product?.name}
              src={i.url}
              className={`${styles.productImage}`} />

            ) :

            <img alt={product?.name} loading='lazy' src={images[0].url} className={`${styles.productImage}`} />}

          </div>
        </AppLink>
        {caller === CallerEnum.ProductGrid &&
        [CardType.Type3, CardType.Type4, CardType.Type6].includes(type) &&
        images.length > 1 &&
        <>
              <button
            className={`${styles.sliderCardButton} ${styles.left}`}
            onClick={(e) => handleMoveSlider(CardSliderDirection.Left, e)}>

                <span className={`${styles.iconArrow} icon-arrow`} />
              </button>
              <button
            className={`${styles.sliderCardButton} ${styles.right}`}
            onClick={(e) => handleMoveSlider(CardSliderDirection.Right, e)}>

                <span className={`${styles.iconArrow} icon-arrow`} />
              </button>
            </>}

        {finalPrice > 0 &&
        <ProductCardSelector
          className={styles.productSelector}
          product={product}
          cartProducts={cartProducts}
          addProduct={addProduct}
          removeProduct={removeProduct}
          manuallyChangeProduct={manuallyChangeProduct}
          theme={theme}
          storeMetadata={storeMetadata} />}


      </figure>
      <AppLink to={urlProductDetail()} Component={ComponentLinks}>
        <div className={styles.topIndicators}>
          {isKit && withTags && <KitTag />}
          {isHighlight && withTags && <HighlightStarBox className={styles.highlightStarBox} />}
          {isWholesale && withTags && <WholesaleBox className={styles.wholesaleBox} />}
        </div>
        <div className={styles.name}>{product.name}</div>
        {finalPrice > 0 &&
        <div className={styles.info}>
            <div className={styles.values}>
              {hasDiscount && !isKit &&
            <div className={styles.withoutDiscountPrice}>{formattedWithoutDiscountPrice}</div>}

              <div className={styles.price}>
                <div className={styles.value}>{formattedFinalPrice}</div>
                {!!percentageDiscount && <div className={styles.discount}>{percentageDiscount}%OFF</div>}
              </div>
              {isKit && <div className={styles.totalUnitsKit}>{product.totalUnits || 0} unidades</div>}
            </div>
          </div>}

      </AppLink>
    </div>);

};

export default ProductCard3;